import React from 'react';
import { ReportOptionWrapper } from '../ReportOption/ReportOption.styles';
import styled from 'styled-components';

const SVG = styled.svg`
    .outer-circle,
    .outer-eye,
    .eye-pupil {
        fill: #fff;
    }
    .outer-circle,
    .upper-lid-line {
        stroke: #8a7333;
        stroke-width: 1.5px;
    }
    .world-icon {
        fill: ${({ theme }) => theme.brown[400]};
        transform-box: fill-box;
        transform-origin: center;
    }
    .world-icon-wrapper {
        transform-box: fill-box;
        transform-origin: center;
        transition: all 0.15s ease-out;
    }
    .eye-line {
        fill: ${({ theme }) => theme.brown[400]};
    }
    .upper-lid-line {
        transform-origin: center;
        transition: all 0.2s ease-out;
        fill: none;
    }
    .eye-pupil-inner {
        stroke: none;
    }
    .eye-pupil-inner {
        fill: ${({ theme }) => theme.brown[400]};
    }

    .eye {
        transition: all 0.15s ease-out;
    }

    .open-eye {
        transition: opacity 0.1s ease-in;
        opacity: 0;
        stroke: ${({ theme }) => theme.brown[400]};
        stroke-width: 1;
    }

    ${ReportOptionWrapper}:hover & {
        .outer-circle {
            fill: ${({ theme }) => theme.brown[100]};
        }
        .world-icon {
            background: white;
            fill-opacity: 1;
            fill-rule: evenodd;
            fill: ${({ theme }) => theme.brown[400]};
        }

        .world-icon-wrapper {
            transform: scale(0.6);
        }

        .eye {
            transform: translate(-49px, -45px) scale(1.3);
        }

        .eye-pupil-inner,
        .upper-lid-line {
            opacity: 0;
        }

        .upper-lid-line {
            transform: skew(5deg, -10deg) scale(0.8);
        }

        .open-eye {
            opacity: 1;
        }
    }
`;

const TransversalViewComponent = () => (
    <SVG width={140.998} height={140.998} viewBox="0 0 140.998 140.998">
        <g transform="translate(0.75 0.75)">
            <path
                className="outer-circle"
                d="M70.469,147.778a69.749,69.749,0,1,1,69.749-69.749,69.749,69.749,0,0,1-69.749,69.749Z"
                transform="translate(-0.72 -8.28)"
            />
            <g className={'world-icon-wrapper'}>
                <circle fill="white" style={{ background: 'white' }} cx="70" cy="70" r="36" />
                <path
                    className="world-icon"
                    d="M9506.672,14850h-.921a37.053,37.053,0,1,1,1.5-.022v.022h-.488l-.086.022Zm-10.51-8.956a32.321,32.321,0,0,0,6.924,5.87,23.567,23.567,0,0,0,2.665,1.453v-15.12h-14.806A34.62,34.62,0,0,0,9496.162,14841.046Zm-15.266-2.944a35.363,35.363,0,0,0,21.616,10.23,33.659,33.659,0,0,1-7.413-6.228,36.382,36.382,0,0,1-5.839-8.855h-12.428A35.627,35.627,0,0,0,9480.9,14838.1Zm26.356,10.167a20.107,20.107,0,0,0,2.013-.872,25.254,25.254,0,0,0,6.507-4.748,30.7,30.7,0,0,0,6.294-9.4h-14.813Zm9.511-4.487a27.163,27.163,0,0,1-5.706,4.36,35.337,35.337,0,0,0,20.043-10.04,35.642,35.642,0,0,0,4.065-4.853H9523.72A32.457,32.457,0,0,1,9516.764,14843.781Zm19.392-12.034a35.361,35.361,0,0,0,5.321-17.5h-14.132c0,.187-.008.372-.012.563a52.61,52.61,0,0,1-3.019,16.935Zm-13.466,0a50.2,50.2,0,0,0,3.146-16.976c0-.175.008-.351.011-.521h-18.593v17.5Zm-16.938,0v-17.5h-19.093a45.27,45.27,0,0,0,3.589,17.5Zm-17.157,0q-.3-.727-.583-1.472a48.35,48.35,0,0,1-2.854-16.025h-14.636a35.422,35.422,0,0,0,5.324,17.5Zm35.9-35.729a48.624,48.624,0,0,1,2.858,16.73H9541.5a35.348,35.348,0,0,0-5.348-18.5h-12.366Q9524.16,14795.12,9524.5,14796.018Zm-17.244,16.73h18.6a45.515,45.515,0,0,0-3.73-18.5h-14.874Zm-20.58-1.223c-.011.414-.019.82-.022,1.223h19.1v-18.5h-15.817A49.934,49.934,0,0,0,9486.673,14811.525Zm-13.383-12.344a35.283,35.283,0,0,0-2.792,13.566h14.65q.006-.627.022-1.264a52.319,52.319,0,0,1,3.135-17.236h-12.459A35.458,35.458,0,0,0,9473.29,14799.182Zm44.118-14.993a36.426,36.426,0,0,1,5.7,8.561h12.057a35.693,35.693,0,0,0-15.347-12.458,35.1,35.1,0,0,0-10.312-2.624A33.327,33.327,0,0,1,9517.408,14784.188Zm-10.155,8.561h14.162a34.49,34.49,0,0,0-5.068-7.5,32.448,32.448,0,0,0-6.925-5.873c-.876-.548-1.621-.947-2.169-1.219Zm-4.014-13.853a25.4,25.4,0,0,0-6.508,4.748,30.574,30.574,0,0,0-6.16,9.1h15.18v-14.9A18.157,18.157,0,0,0,9503.239,14778.9Zm-11.058,1.395a35.689,35.689,0,0,0-15.348,12.458h12.079a32.277,32.277,0,0,1,6.827-10.233,26.6,26.6,0,0,1,6.56-4.826A35.013,35.013,0,0,0,9492.182,14780.291Z"
                    transform="translate(-9436.5 -14743.5)"
                />
            </g>

            <g transform="translate(0 0.253)" className={'eye'}>
                <path
                    className="outer-eye"
                    d="M24,0C37.255,0,48.052,10.081,48,12.5S37.255,25,24,25,.089,15.115,0,12.5,10.745,0,24,0Z"
                    transform="translate(67.752 76.25)"
                />
                <path
                    className="eye-line"
                    d="M24,1.5a27.786,27.786,0,0,0-8.642,1.429A32.965,32.965,0,0,0,8.166,6.3a27.664,27.664,0,0,0-4.927,3.857,7.3,7.3,0,0,0-1.729,2.3,7.568,7.568,0,0,0,1.739,2.309A27.931,27.931,0,0,0,8.158,18.65a32.691,32.691,0,0,0,7.177,3.4A27.593,27.593,0,0,0,24,23.5a27.208,27.208,0,0,0,8.611-1.452,32.9,32.9,0,0,0,7.159-3.416,28.252,28.252,0,0,0,4.93-3.879,8.438,8.438,0,0,0,1.778-2.276,8.252,8.252,0,0,0-1.773-2.273,28.826,28.826,0,0,0-4.94-3.866,33.053,33.053,0,0,0-7.168-3.4A27.317,27.317,0,0,0,24,1.5M24,0C37.255,0,48.052,10.081,48,12.5S37.255,25,24,25,.089,15.115,0,12.5,10.745,0,24,0Z"
                    transform="translate(67.752 76.25)"
                />
                <g className="eye-pupil" transform="translate(84.751 81.25)">
                    <path
                        className="eye-pupil-inner"
                        d="M 7.822392463684082 6.414355278015137 C 7.821387767791748 6.414355278015137 7.820396423339844 6.414356231689453 7.819419384002686 6.41435718536377 C 7.665408134460449 6.436923027038574 7.530469417572021 6.441887855529785 7.436002731323242 6.445364952087402 C 7.242692470550537 6.452474594116211 6.968082427978516 6.459255218505859 6.596482753753662 6.466085433959961 C 5.914732933044434 6.478634834289551 4.999463081359863 6.48968505859375 4.030452728271484 6.501384735107422 C 3.090350151062012 6.51273250579834 1.895630836486816 6.527157783508301 0.9195938110351562 6.544927597045898 C 1.178762435913086 7.185803413391113 1.550441741943359 7.949413299560547 2.067362785339355 8.704935073852539 C 3.497072219848633 10.79456520080566 5.389522552490234 11.85620498657227 7.692132472991943 11.86035537719727 L 7.706042766571045 11.86036491394043 C 8.983963012695312 11.86036491394043 10.05401229858398 11.55210494995117 10.97734260559082 10.91795539855957 C 11.72521209716797 10.40431499481201 12.37033271789551 9.671255111694336 12.89478302001953 8.739145278930664 C 13.28969192504883 8.037265777587891 13.56078910827637 7.319626808166504 13.74406242370605 6.710174560546875 C 11.79501628875732 6.599923133850098 8.471966743469238 6.414355278015137 7.822392463684082 6.414355278015137 M 7.822390556335449 4.91435432434082 C 8.85569953918457 4.91435432434082 15.56904029846191 5.31749153137207 15.58493614196777 5.309610366821289 C 15.57880973815918 5.330330848693848 14.72317314147949 13.37279224395752 7.689452648162842 13.36035537719727 C 0.642582893371582 13.34765434265137 -1.106447219848633 5.248044967651367 -1.0830078125 5.128905296325684 C -1.059567451477051 5.009764671325684 7.663082599639893 4.999995231628418 7.689452648162842 4.922855377197266 C 7.691438674926758 4.917044639587402 7.73810863494873 4.91435432434082 7.822390556335449 4.91435432434082 Z M 15.58495616912842 5.309566497802734 C 15.58496284484863 5.309566497802734 15.58496856689453 5.30959415435791 15.58493614196777 5.309610366821289 C 15.58494472503662 5.309581756591797 15.58495140075684 5.309566497802734 15.58495616912842 5.309566497802734 Z"
                    />
                    <circle className="open-eye" cx={7} cy={8} r={8} />
                </g>
                <path className="upper-lid-line" d="M68.514,88.75a145.738,145.738,0,0,1,46.647,0" />
            </g>
        </g>
    </SVG>
);

export default TransversalViewComponent;
